import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnitOfMeasureOption } from '../../../../shared/services/sage-integration.model';

@Component({
  selector: 'app-wizard-unit-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './wizard-unit-card.component.html',
  styleUrls: ['./sage-wizard.shared.css', './wizard-unit-card.component.css'],
})
export class WizardUnitCardComponent implements OnChanges, AfterViewChecked {
  @ViewChild('unitSelect') private unitSelect?: ElementRef<HTMLSelectElement>;

  @Input() matchId = 0;
  @Input() name = '';
  @Input() code = '';
  @Input() sageUnit = '';
  @Input() itemTypeId = 1;
  /** A Sage service always comes in as an Aivor service, so there's no item type to choose. */
  @Input() isService = false;
  @Input() units: UnitOfMeasureOption[] = [];
  @Input() selectedUomId: number | null = null;
  @Input() answered = false;
  @Input() saving = false;

  @Output() itemTypeChange = new EventEmitter<number>();
  @Output() unitChange = new EventEmitter<number>();

  // Variable items (3) are kept out of Sage for now, so they aren't offered here.
  readonly itemTypes = [
    { id: 1, label: 'Raw material' },
    { id: 2, label: 'Finished good' },
  ];

  private selectStale = true;

  // After a failed save Angular wouldn't redraw the select (its options' bindings are unchanged),
  // so it is put back by hand. Not while saving, or the choice would flick back early.
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedUomId'] || changes['units'] || (changes['saving'] && !this.saving)) this.selectStale = true;
  }

  ngAfterViewChecked(): void {
    if (!this.selectStale || !this.unitSelect) return;
    this.selectStale = false;
    this.showSavedUnit();
  }

  private showSavedUnit(): void {
    if (this.unitSelect) this.unitSelect.nativeElement.value = this.selectedUomId ? String(this.selectedUomId) : '';
  }

  get description(): string {
    const code = this.code ? `${this.code}. ` : '';
    return this.sageUnit
      ? `${code}Sage calls the unit "${this.sageUnit}", and Aivor does not have that unit. Choose one for Aivor.`
      : `${code}Sage has no unit for this item. Choose one for Aivor.`;
  }

  onSelect(value: string): void {
    const id = Number(value);
    if (id) this.unitChange.emit(id);
  }
}
